import React from 'react';
import { AutoComplete } from 'antd';

export default function KoAutoComplete(props) {
  return (
    <AutoComplete {...props}/>
  );
}
